import * as React from 'react';

import {Button} from 'shells/button/button';
import {Body} from 'shells/typography/body';

type Props = {
    service: 'CONNECT_ZOOM' | 'CONNECT_GOOGLE';
    copy: string;
};

export function TranscriptSummaryConnectService(props: Props) {
    const handleConnectService = () => {
        if (props.service === 'CONNECT_ZOOM') {
            window.location.href = '/sales/meetings/zoom';
        } else if (props.service === 'CONNECT_GOOGLE') {
            window.location.href = '/sales/meetings/meet';
        }
    };

    return (
        <div className='flex align-center justify-sb'>
            <Body size='small'>{props.copy}</Body>
            <Button variant='primary' onClick={handleConnectService}>
                Connect
            </Button>
        </div>
    );
}
